export var REALTIME_COMPONENT_NAMES;
(function (REALTIME_COMPONENT_NAMES) {
    REALTIME_COMPONENT_NAMES["realtime"] = "realtime";
    REALTIME_COMPONENT_NAMES["server"] = "server";
    REALTIME_COMPONENT_NAMES["chat"] = "chat";
})(REALTIME_COMPONENT_NAMES || (REALTIME_COMPONENT_NAMES = {}));
